<template>
  <div>
    <div class="user">
      <div class="user-left">
        <div class="img">
          <img
            :src="userInfo.avatar || '@assets/pc/images/home/user-bg.png'"
            alt=""
          />
        </div>
        <div class="detail">
          <div class="detail-name">{{ userInfo.nickname }}，欢迎您！</div>
          <div class="account">
            <router-link to="/home/changePassword">修改密码</router-link>
          </div>
          <div class="tel">手机：{{ userInfo.phone }}</div>
        </div>
      </div>
      <div class="user-right">
        <div @click="changeUrl(0)">全部订单</div>
        <div @click="changeUrl(1)">待支付订单</div>
        <div @click="changeUrl(2)">我的收藏</div>
        <div @click="changeUrl(3)">管理收货地址</div>
      </div>
    </div>
    <div class="current-order">
      <div class="title">最近订单</div>
      <div class="content" v-if="orderList.length > 0">
        <div class="item" v-for="item of orderListFilter" :key="item.id">
          <div class="item-title">
            <div class="item-title--time">{{ item._add_time }}</div>
            <div class="item-title--num">
              订单号：<span>{{ item.order_id }}</span>
            </div>
          </div>
          <div class="item-content">
            <div class="item-content--header">
              <div
                class="product-num"
                v-for="val of item.cartInfo"
                :key="val.id"
              >
                <div class="img">
                  <img :src="val.productInfo.image" alt="" />
                </div>
                <div class="name">
                  {{ val.productInfo.store_name }}
                </div>
                <div class="number">x{{ val.cart_num }}</div>
              </div>
            </div>
            <div class="item-content--name">{{ item.real_name }}</div>
            <div class="item-content--money">
              <div class="total">总额 ¥{{ item.pay_price }}元</div>
              <div class="tip">（含运费：￥{{ item.pay_postage }}）</div>
              <div class="pay-type">{{ item._status._payType }}</div>
            </div>
            <div class="item-content--pay">
              <div>{{ item._status._title }}</div>
              <div @click="goBuy(item.order_id)">订单详情</div>
            </div>
            <div class="item-content--btn">
              <div @click="goBuy(item.order_id)">
                <span v-if="item._status._type === 0">立即付款</span>
                <span v-else>查看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-else>
        <div class="item-none">
          <div class="img">
            <img src="../../../assets/pc/images/home/none.png" alt="" />
          </div>
          <div class="tip">
            暂无订单，这就去
            <span>
              <router-link to="/">商城首页</router-link>
            </span>
            挑选商品！
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getOrderList } from "@api/order";
export default {
  name: "HomeIndex",
  data() {
    return {
      orderList: []
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    orderListFilter() {
      return this.orderList.filter((item, index) => {
        return index < 5;
      });
    }
  },
  created() {
    this.getProdectList();
  },
  methods: {
    getProdectList() {
      getOrderList(this.params)
        .then(res => {
          this.orderList = res.data;
        })
        .catch(err => {
          if (err.msg === "系统出现异常") {
            this.$router.go(0);
          }
        });
    },
    goBuy(id) {
      this.$router.push({
        path: "/home/orderDetail/" + id
      });
    },
    changeUrl(index) {
      if (index === 0) {
        this.$router.push({
          path: "/home/myOrder"
        });
      } else if (index === 1) {
        this.$router.push({
          path: "/home/myOrder?active=0"
        });
      } else if (index === 2) {
        this.$router.push({
          path: "/home/goodsCollection"
        });
      } else {
        this.$router.push({
          path: "/home/myAddress"
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.user
  border 1px solid #e3e3e3
  display flex
  &-left
    width 500px
    display flex
    padding 20px
    .img
      width 110px
      height 110px
      border-radius 50%
      overflow hidden
      margin 10px
      img
        width 100%
        height 100%
    .detail
      margin-left 10px
      &-name
        font-size 18px
        line-height 30px
        color #333
      .account
        margin-top 5px
        line-height 16px
        font-size 12px
        font-family '宋体'
        color #6776db
      .tel
        margin-top 55px
        color #666
        font-family '宋体'
  &-right
    flex 1
    border-left 1px solid #e3e3e3
    display flex
    flex-wrap wrap
    div
      width 50%
      line-height 84px
      font-size 16px
      color #333
      cursor pointer
      padding-left 80px
      position relative
      &:after
        content ''
        display inline-block
        position absolute
        left 30px
        top 22px
        width 42px
        height 42px
        background-image url(../../../assets/pc/images/home/home.png)
        background-repeat no-repeat
        transition all 0.2s linear
      &:first-child
        border-right 1px solid #e3e3e3
        border-bottom 1px solid #e3e3e3
        &:after
          background-position 0 -93px
        &:hover
          &:after
            background-position 0 -139px
      &:nth-child(2)
        border-bottom 1px solid #e3e3e3
        &:after
          background-position -46px -93px
        &:hover
          &:after
            background-position -46px -139px
      &:nth-child(3)
        border-right 1px solid #e3e3e3
        &:after
          background-position -92px -93px
        &:hover
          &:after
            background-position -92px -139px
      &:last-child
        &:after
          background-position -139px -93px
        &:hover
          &:after
            background-position -139px -139px
.current-order
  margin-top 20px
  .title
    line-height 42px
    background #f5f8fa
    position relative
    padding-left 48px
    color #546d7e
    font-size 16px
    &:before
      content ''
      display inline-block
      position absolute
      left 15px
      top 10px
      width 24px
      height 24px
      background-image url(../../../assets/pc/images/home/home.png)
      background-repeat no-repeat
      background-position -421px -54px
  .content
    margin-top 20px
    margin-bottom 30px
    .item
      margin-top 20px
      border 1px solid #f5f5f5
      &-title
        line-height 34px
        background #f5f5f5
        display flex
        color #aaa
        &--time
          padding 0 30px 0 15px
        &--num
          font-family '宋体'
          span
            color #333
            font-family 'Microsoft yahei'
      &-content
        display flex
        font-size 13px
        &--header
          width 420px
          border-right 1px solid #f5f5f5
          .product-num
            display flex
            padding 20px 0
            border-bottom 1px solid #f5f5f5
            &:last-child
              border-bottom 0
            .img
              width 68px
              height 68px
              border 1px solid #f5f5f5
              align-self center
              margin 0 15px
              img
                width 100%
                height 100%
            .name
              width 200px
              margin-top 15px
              margin-right 60px
              height 36px
              color #555
              display -webkit-box !important
              overflow hidden
              text-overflow ellipsis
              word-break break-all
              -webkit-box-orient vertical
              -webkit-line-clamp 2
            .number
              margin-top 15px
              font-family 'Microsoft yahei'
              color #aaa
        &--name
          width 90px
          text-align center
          padding-top 30px
          color #555
          border-right 1px solid #f5f5f5
        &--money
          width 200px
          padding-top 30px
          text-align center
          border-right 1px solid #f5f5f5
          color #555
          .total
            margin-bottom 10px
          .tip
          .pay-type
            color #9b9b9b
            font-size 12px
        &--pay
          color #555
          padding-top 30px
          width 100px
          border-right 1px solid #f5f5f5
          text-align center
          div:first-child
            margin-bottom 10px
            color #9b9b9b
          div:last-child
            cursor pointer
        &--btn
          padding-top 30px
          margin 0 auto
          div
            cursor pointer
            text-align center
            padding 0 5px
            height 22px
            line-height 22px
            background #4889f6
            color #fff
            border-radius 2px
            font-family '宋体'
            min-width 62px
    .item-none
      min-height 150px
      .img
        margin 100px auto 20px
        width 80px
        height 50px
        img
          width 100%
          height 100%
      .tip
        text-align center
        color #aaa
        span
          color #1880f4
</style>
